import { render } from "./SelecionarVariavelCobranca.vue?vue&type=template&id=4e8e2fa9&ts=true"
import script from "./SelecionarVariavelCobranca.vue?vue&type=script&lang=ts"
export * from "./SelecionarVariavelCobranca.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__